import React from "react"
import { Router } from "@reach/router";
import NewLoanForm from "../pages/NewLoan"
import { UserContextProvider } from "../context/user";
import { initReactApp } from "../utils/init"

const App = (): JSX.Element => {
  return (
    <UserContextProvider>
      <Router>
        <NewLoanForm path=":locale/loans/new" />
      </Router>
    </UserContextProvider>
  );
};

initReactApp(<App />);
